/* Кнопка бесплатного набора на каждой странице витрины.
   Заведена 24.08.2026 по просьбе Михаила. Заодно тут же запоминаются метки
   рекламы: человек приходит с объявления на главную, а до формы добирается
   позже, и без этого параметры адреса теряются на первом же клике. */
(function () {
  function метки() {
    var сюда = {};
    try {
      var было = sessionStorage.getItem('dana_attr');
      if (было) сюда = JSON.parse(было) || {};
    } catch (e) {}
    var п = new URLSearchParams(location.search);
    // Сырые параметры адреса. campaign_param и ad_param названы иначе, чем
    // считанные campaign и ad: раньше имена совпадали, и считанное значение
    // затирало сырое, а потом само же читалось как сырое.
    var поля = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content',
                'utm_term', 'gclid', 'fbclid', 'ttclid'];
    var пары = { campaign: 'campaign_param', ad: 'ad_param' };
    var новое = false;
    for (var i = 0; i < поля.length; i++) {
      var v = п.get(поля[i]);
      if (v && !сюда[поля[i]]) { сюда[поля[i]] = v.slice(0, 200); новое = true; }
    }
    for (var к in пары) {
      var w = п.get(к);
      if (w && !сюда[пары[к]]) { сюда[пары[к]] = w.slice(0, 200); новое = true; }
    }
    if (!сюда.landing) { сюда.landing = location.pathname.slice(0, 200); новое = true; }
    if (!сюда.referrer) { сюда.referrer = (document.referrer || '').slice(0, 200); новое = true; }
    if (!сюда.first_seen) { сюда.first_seen = new Date().toISOString(); новое = true; }
    if (новое) { try { sessionStorage.setItem('dana_attr', JSON.stringify(сюда)); } catch (e) {} }
  }

  function нельзя() {
    var п = location.pathname;
    return п.indexOf('/pages/sample-kit') === 0
      || п.indexOf('/pages/inbox') === 0
      || п.indexOf('/pages/audit') === 0
      || п.indexOf('/checkouts') === 0
      || п.indexOf('/challenge') === 0;
  }

  function кнопка() {
    if (нельзя() || document.getElementById('dana-kit-cta')) return;
    var с = document.createElement('style');
    с.textContent =
      '#dana-kit-cta{position:fixed;right:16px;bottom:16px;z-index:44;'
      + 'background:#af95c6;color:#fff;text-decoration:none;border-radius:999px;'
      + "padding:13px 20px;font-family:'Josefin Sans',sans-serif;"
      + 'text-transform:uppercase;letter-spacing:.05em;font-size:14px;'
      + 'box-shadow:0 6px 20px rgba(21,21,21,.22);display:inline-flex;'
      + 'align-items:center;gap:8px;line-height:1;transition:transform .15s,'
      + 'box-shadow .15s;max-width:calc(100vw - 32px);box-sizing:border-box}'
      + '#dana-kit-cta:hover{transform:translateY(-2px);'
      + 'box-shadow:0 10px 26px rgba(21,21,21,.28);color:#fff}'
      + '#dana-kit-cta b{font-weight:700}'
      + '@media (max-width:600px){ #dana-kit-cta{right:12px;bottom:12px;'
      + 'padding:12px 16px;font-size:13px} }'
      + '@media print{ #dana-kit-cta{display:none} }';
    document.head.appendChild(с);
    var а = document.createElement('a');
    а.id = 'dana-kit-cta';
    а.href = '/pages/sample-kit';
    а.setAttribute('aria-label', 'Apply to test our products');
    а.innerHTML = '<span>&#128156;</span><b>Apply to Test</b>';
    document.body.appendChild(а);
    развести();
  }

  // Зеленая кнопка вотсапа стоит в том же углу. Ставим свою над ней и меряем
  // ее высоту живьем: чат сам уезжает вверх, когда снизу вылезает липкая
  // полоса корзины, и зашитое число тут разъедется.
  function развести() {
    var а = document.getElementById('dana-kit-cta');
    var чат = document.getElementById('danaChat');
    if (!а) return;
    if (!чат) { а.style.bottom = ''; return; }
    var к = чат.getBoundingClientRect();
    if (!к.height) return;
    var зазор = window.innerWidth <= 600 ? 10 : 12;
    а.style.bottom = ((window.innerHeight - к.bottom) + к.height + зазор) + 'px';
  }

  function следить() {
    развести();
    window.addEventListener('resize', развести);
    var чат = document.getElementById('danaChat');
    if (чат) чат.addEventListener('transitionend', развести);
    var полоса = document.getElementById('danaSatc');
    if (полоса && window.MutationObserver) {
      new MutationObserver(function () {
        развести();
        setTimeout(развести, 260);
      }).observe(полоса, {attributes: true, attributeFilter: ['aria-hidden']});
    }
    // чат подключается своим снипетом, порядок загрузки не гарантирован
    setTimeout(развести, 400);
    setTimeout(развести, 1200);
  }

  метки();
  function запуск() { кнопка(); следить(); }
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', запуск);
  else запуск();
})();
